<template>
  <div class="search-container">
    <div class="search-content">
      <div class="search-top">
        <i class="el-icon-close close-icon" @click="cancleDelete"></i>
          请扫描二维码进行跳转小程序
      </div>
      <div class="img-container">
        <img class="code-img"  v-if="imgSrc.length>0" :src="imgSrc" alt="" >
        <span class="load-icon el-icon-loading" v-else></span>
      </div>
    </div>
  </div>
</template>

<script type='text/ecmascript-6'>
export default {
  data () {
    return {
      imgSrc: ''
    }
  },
  props: ['order'],
  mounted() {
    this.initImg(this.order)
  },
  methods: {
    cancleDelete () { // 取消删除
      this.$emit('closeimg', ' ')
      this.imgSrc =''
    },
    initImg (order_id) {
      this.$api.getImgCode({
        order_id: `o${order_id}`
      }).then(res => {
        if (res.data.msg === true) {
          // this.imgSrc = res.data.qrcode_url
          let newImg = new Image()
          newImg.src = res.data.qrcode_url
          newImg.onerror = () => { // 图片还没有加载成功的时候不能显示图片
            newImg.src = ''
          }
          newImg.onload = () => { // 当图片加载成功的时候 给imgSrc 进行赋值显示图片
            this.imgSrc = newImg.src
          }
        } else {
          this.$message({
            showClose: true,
            message: '缺少委托单号',
            type: 'error'
          })
        }
      })
    }
  },
  watch: {
    /* order (newValue) {
      console.log(newValue)
      this.initImg(newValue)
    } */
  }
}
</script>

<style lang='stylus' rel='stylesheet/stylus'>
.search-container
  position:fixed;
  left:0;
  right:0;
  top:0;
  bottom:0;
  background-color:rgba(0, 0, 0, 0.2);
  z-index:10000;
  display: flex;
  justify-content: center;
  align-items: center;
  .search-content
    background:#fff;
    z-index: 100001;
    width: 24rem;
    padding: 0rem;
    border-radius: 0.4rem;
    position: relative;
    overflow:hidden;
    .search-top
      line-height: 3rem;
      background: #1D489E;
      color: #fff;
      font-size:0.8rem;
      text-align: center;
      font-weight:bold;
    .img-container
      width:100%;
      border: 1px solid #ECECEC;
      padding:40px 0px;
      margin: 1rem auto 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      width:20rem;
      height:20rem;
      .code-img
        display:block;
        margin:0px auto;
        /* width:100%;
        height:100%; */
    .close-icon
      position: absolute;
      top:0.5rem;
      right:0.5rem;
      color:#fff;
      font-size:1.2rem;
</style>
